// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"77f6250e","331":"77f6250e","367":"77f6250e","830":"77f6250e","867":"77f6250e"}[chunkId] + ".chunk.css";
};